import React from 'react';
import { Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import styles from '../styles';
import {
  isArray,
  isBoolean,
  isUndefined,
  isObject,
  isStringEmpty
} from '../../../utils/isDefined';

const UserDetailsTable = ({ data, classes }) => {
  if (isUndefined(data) || !isObject(data)) {
    return null;
  }

  return (
    <Table size="small" className={classes.table}>
      <TableBody>
        {Object.keys(data).map(key => {
          const value = data[key];
          const label = labelFromKey(key);

          return (
            <TableRow key={key}>
              <TableCell className={classes.labelCell}>{label}</TableCell>
              <TableCell className={classes.valueCell}>
                {isObject(value) ? (
                  <UserDetailsTable data={value} classes={classes} />
                ) : (
                  formatValue(value)
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default withStyles(styles)(UserDetailsTable);

const labelFromKey = key =>
  key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/^./, char => char.toUpperCase());

const formatValue = value => {
  if (isUndefined(value) || isStringEmpty(value)) {
    return '-';
  }
  if (isBoolean(value)) {
    return value.toString();
  }
  if (isArray(value)) {
    return value.length ? value.join(', ') : '-';
  }
  return value;
};
